import React from "react"
import ProductCard2 from "./ProductCard2"

const ProductList = React.memo(({ products = [] }) => {
  if (!products.length) return null

  return (
    <div className="product-grid">
      {products.map((p) => (
        <ProductCard2 key={p.product_id} product={p} />
      ))}
    </div>
  )
})

export default ProductList
